import React from 'react';
import { Flex } from 'antd';
import { I18n } from 'react-redux-i18n';

import ModelFile from 'modules/Negoce/components/DownloadModels/ModelFile';

const Models = () => {
  return (
    <Flex vertical justify="space-around" className="sizeFiles">
      {/* <ModelFile
        label={I18n.t('negoce.submissions.modelFiles.modelWS')}
        fileName="Template_ventes.xslx"
        filePath="https://negociant-templates.s3.eu-west-1.amazonaws.com/Template_ventes_courtier.xlsx"
      /> */}
      <ModelFile
        label={I18n.t('negoce.submissions.modelFiles.modelBordeaux')}
        fileName="Template_ventes_Bordeaux_négoce.xslx"
        filePath="https://negociant-templates.s3.eu-west-1.amazonaws.com/Template_ventes_Bordeaux_négoce.xlsx"
      />
    </Flex>
  );
};

export default Models;
